// extracted by extract-css-chunks-webpack-plugin
module.exports = {"searchBar":"_3PBJY0","button":"_1UJQtk","results":"_1_snvi","result":"_33_vLV","inputHolderInner":"_21tYmi","closeMobile":"_18Hca3"};